<template>
  <div v-if="internalValue" id="applicant-edit-tab-personal-data">
    <div class="flex flex-wrap flex-row">
      <DataInput
        v-model="internalValue.title"
        required
        validation-rules="required"
        class="w-1/2 mt-4 pr-3"
        label="Titel"
        name="title"
      />

      <DataInput
        v-model="internalValue.company"
        type="model"
        class="w-1/2 mt-4 pr-3"
        label="Firma"
        name="company"
        required
        validation-rules="required"
        model-label="
          name
          landwehrId"
        :select-label="el => el.name + ' ' + (el.landwehrId ? '- L1' : '')"
        gql-filter-type="objectFilter"
        gql-query="companies"
      />

      <div class="w-full mb-2 pl-3 pr-3 flex flex-wrap flex-row">
        <DataInput
          v-model="internalValue.vacancyAmount"
          type="number"
          class="w-1/5 mt-4 pr-3"
          label="Anzahl Positionen"
          name="vacancyAmount"
        />

        <DataInput
          v-model="internalValue.vacancyAmountOccupied"
          type="number"
          class="w-1/5 mt-4 pr-3"
          label="Positionen besetzt"
          name="vacancyAmountOccupied"
        />
      </div>

      <DataInput
        v-model="internalValue.projectState"
        required
        validation-rules="required"
        type="select"
        class="w-1/2 mt-4 pr-3"
        :options="projectState"
        label="Status"
        name="projectState"
      />

      <DataInput
        v-model="internalValue.closeReason"
        type="model"
        class="w-1/2 mt-4 pr-3"
        label="abgeschlossen weil"
        name="closeReason"
        gql-query="vacancyCloseReasons"
      />

      <DataInput
        v-model="internalValue.consultantID"
        :initial-value="internalValue.consultant"
        required
        validation-rules="required"
        type="model"
        class="w-1/3 mt-4 pr-3"
        label="Berater"
        name="consultant"
        model-label="
          firstName
          lastName"
        :select-label="el => el.firstName + ' ' + el.lastName"
        gql-query="consultantsPage"
        gql-single-query="consultant"
        gql-filter-type="objectFilter"
      />

      <DataInput
        v-model="internalValue.userGroup"
        type="model"
        class="w-1/3 mt-4 pr-3"
        label="Benutzergruppe"
        name="userGroup"
        gql-query="userGroups"
      />

      <DataInput
        v-model="internalValue.projectStage"
        type="model"
        class="w-1/3 mt-4 pr-3"
        label="Phase"
        name="projectStage"
        gql-query="vacancyPhases"
      />

      <DataInput
        v-model="internalValue.contractDate"
        type="date"
        class="w-1/3 mt-4 pr-3"
        label="Vertrag Datum"
        name="contractDate"
      />

      <DataInput
        v-model="internalValue.requestedAt"
        type="date"
        class="w-1/3 mt-4 pr-3"
        label="Angefordert am"
        name="requestedAt"
      />

      <DataInput
        v-model="internalValue.closedAt"
        type="date"
        class="w-1/3 mt-4 pr-3"
        label="Abschluss am"
        name="closedAt"
      />

      <DataInput
        v-model="internalValue.description"
        type="html"
        class="w-full mt-4 pr-3"
        label="Beschreibung"
        name="description"
      />

      <DataInput
        v-model="internalValue.skillJobTypeID"
        :initial-value="internalValue.skillJobType"
        type="model"
        class="w-full md:w-1/5 lg:w-1/3 mt-4 pl-3 pr-3"
        label="Berufsgruppe"
        name="skillJobType"
        gql-query="applicantSkillJobTypes"
      />

      <DataInput
        v-model="internalValue.occupationID"
        :initial-value="internalValue.occupation"
        type="model"
        class="w-full md:w-1/5 lg:w-1/3 mt-4 pl-3 pr-3"
        label="Beruf"
        name="occupation"
        gql-query="occupations"
      />
    </div>
  </div>
</template>

<script>
import DataInput from "@/components/ui/DataInput";
import projectState from "@/data/enums/ProjectState.js";

export default {
  components: {
    DataInput
  },
  props: {
    value: { type: Object, required: true }
  },
  data: () => ({
    projectState
  }),
  computed: {
    internalValue: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      }
    }
  }
};
</script>
